import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useFetchSections, useFetchSectionsbyPage } from "./Actions/FetchContent";

const TopBar = () => {
  const [currentText, setCurrentText] = useState(0);
  const [shouldScroll, setShouldScroll] = useState(false);
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const { data } = useFetchSections("74");
  const [values, setValues] = useState([]);

  useEffect(() => {
    if (data && data.length > 0) {
      const barData = data.filter((item) => item.secid === 74);
      setValues(barData);
    }
  }, [data]);

  const { sections: sectionsPage } = useFetchSectionsbyPage("38");

  const textLiness =
    values.length > 0
      ? values.map((item) => ({ text: item.question, link: item.answer }))
      : [];

  // Rotate every 10s
  useEffect(() => {
    if (textLiness.length === 0) return;
    const interval = setInterval(() => {
      setCurrentText((prevText) => (prevText + 1) % textLiness.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [textLiness.length]);

  // Overflow check
  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current && containerRef.current) {
        const textWidth = textRef.current.scrollWidth;
        const containerWidth = containerRef.current.offsetWidth;
        setShouldScroll(textWidth > containerWidth);
      }
    };

    const observer = new ResizeObserver(checkOverflow);
    if (containerRef.current) observer.observe(containerRef.current);

    checkOverflow();
    return () => observer.disconnect();
  }, [currentText, textLiness]);

  const renderLink = (item) => {
    if (!item || !item.text) return null;

    if (!item.link) {
      return (
        <span className="text-white font-bold text-[14px] font-manrope">
          {item.text}
        </span>
      );
    }

    const isExternal = /^(http|https|\/\/)/i.test(item.link);
    if (isExternal) {
      return (
        <a
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white font-bold text-[14px] font-manrope"
        >
          {item.text}
        </a>
      );
    }

    return (
      <Link
        to={item.link}
        className="text-white font-bold text-[14px] font-manrope"
      >
        {item.text}
      </Link>
    );
  };

  return (

    <div>
      {sectionsPage[0]?.status === 'Y' && (


        <div
          ref={containerRef}
          style={{
            background: "linear-gradient(114.41deg,#006241 20.74%,#006241 65.5%)",
            color: "white",
            height: "40px",
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            position: "relative",
            paddingLeft: "20px",
            paddingRight: "20px",
            whiteSpace: "nowrap",
          }}
        >
          {textLiness.length > 0 ? (
            shouldScroll ? (
              <div className="marquee w-full text-center">
                <span
                  key={currentText} // 👈 Force correct re-render
                  ref={textRef}
                  className="marquee-text"
                >
                  {renderLink(textLiness[currentText])}
                </span>
              </div>
            ) : (
              <p
                key={currentText} // 👈 Force correct re-render
                ref={textRef}
                className="font-manrope font-bold text-[14px] text-white text-center w-full"
                style={{ whiteSpace: "nowrap" }}
              >
                {renderLink(textLiness[currentText])}
              </p>
            )
          ) : (
            <p className="font-manrope font-bold text-[14px] text-white text-center w-full">
              No announcements
            </p>
          )}

          <style>
            {`
          .marquee {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
          }
          .marquee-text {
            display: inline-block;
            padding-right: 100%;
            animation: marquee 25s linear infinite;
          }
          .marquee-text:hover {
            animation-play-state: paused;
          }
          @keyframes marquee {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-100%); }
          }
        `}
          </style>
        </div>
      )}
    </div>
  );
};

export default TopBar;
